import { createApp } from '@wu/widget-core';
import { AnnouncementBar } from './announcement-bar';
import { meta } from './constants/meta';

export default createApp(meta, AnnouncementBar);
